import PrivateSellersService from '@/api/privateSellersService';
import {
  ArtistItem,
  GallerySystemArtist,
  SingleArtistData,
  SingleArtworkData,
  ArtworksRecord,
  Data,
} from '@/dataTypes/types';

import { defineStore } from 'pinia';

type searchParams = {
  keyword?: string;
  limit?: number;
  offset?: number;
};

export const usePrivateSellersStore = defineStore({
  id: 'privateSeller',
  state: () => ({
    myArtists: [] as ArtistItem[],
    artist: {} as SingleArtistData,
    artwork: {} as SingleArtworkData,
    privateSellerArtworks: [] as ArtworksRecord[],
    privateSellerArtworksLength: [] as ArtworksRecord[],
    privateSellerAllArtists: [] as GallerySystemArtist[],
    privateSellerInfo: {} as Data,
  }),
  getters: {},
  actions: {
    async getAllArtists(data: searchParams) {
      const response = await PrivateSellersService.getAllSystemArtists(data);
      this.privateSellerAllArtists = response.items;
      return response.items;
    },
    async fetchMyArtists(keyword = '', limit = 10000000, offset = 0) {
      const artists = await PrivateSellersService.getMyArtists(
        keyword,
        limit,
        offset
      );
      console.log({ artists });
      this.myArtists = artists;
      return artists;
    },
    async fetchArtist(id: number) {
      const artist = await PrivateSellersService.getArtist(id);
      this.artist = artist;
      return artist;
    },
    async getArtwork(id: number) {
      const artwork = await PrivateSellersService.getArtwork(id);
      this.artwork = artwork;
      return artwork;
    },
    async createArtist(artist: any) {
      const response = await PrivateSellersService.createArtist(artist);
      this.fetchMyArtists();
      return response;
    },
    async updateArtist(id: number, artist: any) {
      const response = await PrivateSellersService.updateArtist(id, artist);
      this.fetchMyArtists();
      return response;
    },
    async addArtistToPrivateSeller(id: number) {
      const response = await PrivateSellersService.addArtistToPrivateSeller(id);
      this.fetchMyArtists();
      return response;
    },
    async removeArtistFromPrivateSeller(id: number) {
      const response =
        await PrivateSellersService.removeArtistFromPrivateSeller(id);
      this.fetchMyArtists();
      return response;
    },
    async saveOrderOfArtists(sortOrder: any) {
      const response = await PrivateSellersService.saveArtistsOrder(sortOrder);
      return response;
    },
    async saveOrderOfArtwork(sortOrder: any) {
      const response = await PrivateSellersService.saveArtworkOrder(sortOrder);
      return response;
    },
    async getMyArtworks(keyword = '', limit = 1000, offset = 0) {
      const data = await PrivateSellersService.getMyArtworks(
        keyword,
        limit,
        offset
      );
      this.privateSellerArtworks = data.items;
      return data.items;
    },
    async getMyArtworksLength(keyword = '', limit = 10000, offset = 0) {
      const data = await PrivateSellersService.getMyArtworks(
        keyword,
        limit,
        offset
      );
      this.privateSellerArtworksLength = data.items;
      return data.items;
    },
    async updateArtwork(id: number, artwork: any) {
      const response = await PrivateSellersService.updateArtwork(id, artwork);
      this.privateSellerArtworks.filter((artwork) => artwork.id === id);
      this.getMyArtworks();
      return response;
    },
    async createArtwork(artwork: any) {
      const response = await PrivateSellersService.createArtwork(artwork);
      this.getMyArtworks();
      return response;
    },
    async deleteArtwork(id: number) {
      const response = await PrivateSellersService.deleteArtwork(id);
      return response;
    },
    async getInfo() {
      const data = await PrivateSellersService.getInfo();
      this.privateSellerInfo = data;
      return data;
    },
    async updateInfo(data: any) {
      const response = await PrivateSellersService.updateInfo(data);
      this.getInfo();
      return response;
    },
    async getAttachments(params?: any) {
      return await PrivateSellersService.getAttachments(params);
    },
    async addAttachment(attachment: any) {
      return await PrivateSellersService.createAttachment(attachment);
    },
    async deleteAttachment(id: number, data?: any) {
      return await PrivateSellersService.deleteAttachment(id, data);
    },
    clearState() {
      this.myArtists = [] as ArtistItem[];
      this.artist = {} as SingleArtistData;
      this.artwork = {} as SingleArtworkData;
      this.privateSellerArtworks = [] as ArtworksRecord[];
      this.privateSellerArtworksLength = [] as ArtworksRecord[];
      this.privateSellerAllArtists = [] as GallerySystemArtist[];
      this.privateSellerInfo = {} as Data;
    },
  },
});
